import { render, staticRenderFns } from "./BasicData.vue?vue&type=template&id=dfa1a72c&"
import script from "./BasicData.vue?vue&type=script&lang=js&"
export * from "./BasicData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports